<div class="p-2">
    <mat-card>
      <mat-card-header fxLayout="column">
        <mat-card-subtitle fxLayout="row" fxLayoutAlign="center center">
          <!-- <h2>{{ 'MSG.CONFIRM-APPOINTMENT' | translate }}</h2> -->
        </mat-card-subtitle>
      </mat-card-header>

      <mat-card-content fxLayout="row" fxLayoutAlign="center center">
        <div fxLayout="column">
          <table>
              <tr>
                <td>{{ 'MSG.FOR' | translate }}: </td><td>{{ patientName }}</td>
              </tr>
              <tr>
                <td>{{ 'MSG.TO-DOCTOR' | translate }}: </td><td>{{ schedulerName }} <span *ngIf="practiceName">({{ practiceName }})</span></td>
              </tr>
              <tr>
                <td style="vertical-align: top;">{{ 'MSG.VISIT-REASON' | translate }}: </td>
                <td>
                  <ul>
                    <li *ngFor="let reason of reasons"><span>{{reason.Name}}</span> <span class="ml-2 mr-2">|</span> <span>{{reason.Duration}} {{'TIME.MINS' | translate}}</span></li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td>{{ 'MSG.DATE' | translate }}: </td><td>{{ startDate | amDateFormat: 'ddd' }}, {{ startDate | amDateFormat: 'L' }}</td>
              </tr>
              <tr>
                <td>{{ 'MSG.TIME' | translate }}: </td><td>{{ startTime }}</td>
              </tr>
              <tr>
                <td> <!--empty spacer--> </td>
              </tr>
              <tr>
                <td> <!--empty spacer--> </td>
              </tr>
          </table>

          <div class="fullAdress">{{ fullBranchAddress }}</div>

          <div class="p-2 py-4" fxLayout="column" fxLayoutAlign="center center">
            <mat-icon class="mat-icon-xlg green">done</mat-icon>
            <h2 class="m-1 center"> {{ 'MSG.APPOINTMENT-SAVED-SUCCESSFULLY' | translate }}!</h2>
          </div>

          <div class="m-1" fxLayoutAlign="center">
              <button mat-stroked-button color="primary" class="m-1" (click)="onNewAppointment()">{{ 'MSG.CREATE-NEW-APP' | translate }}</button>
              <button mat-stroked-button color="primary" class="m-1" (click)="onBack()">{{ 'APP.BACK' | translate }}</button>
          </div>

        </div>
      </mat-card-content>

    </mat-card>
  </div>
